<template>
  <router-view
    :items="items"
    :items_s="items_s"
    :detail="detail"
    :items_reco="items_reco"
    :loading="state.isLoading"
    @get-detail-page="setDetailPageID"
    @get-detail-page-s="setDetailPageID_s"
  ></router-view>
</template>

<script lang="ts">
import { onMounted, reactive, computed } from 'vue'
import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'MypageVisitApplication',

  setup() {
    const items = reactive<any>([])
    const items_s = reactive<any>([])
    const items_reco = reactive<any>([])
    const state = reactive<any>({
      isLoading: true
    })

    onMounted(() => {
      const getList = axiosSetting('app', 'page')

      getList
        .get('/api/v1/inspection_list')
        .then((res) => {
          res.data.forEach((item: any) => {
            items.push(item)
          })

          if (res.data.length == 0) {
            getList
              .get('/api/v1/j_search/recommend')
              .then((res_reco) => {
                console.log(res_reco.data)
                res_reco.data.forEach((item: any) => {
                  items_reco.push(item)
                })
              })
              .then(() => {
                state.isLoading = false
              })
          } else {
            state.isLoading = false
          }
        })
        .catch(() => {
          state.isLoading = false
        })

      getList
        .get('/api/v1/s_inspection_list')
        .then((res) => {
          res.data.forEach((item: any) => {
            items_s.push(item)
          })
          state.isLoading = false
        })
        .catch(() => {
          state.isLoading = false
        })
    })

    const detailPage = reactive<any>({
      id: 0,
      isSeminar: false
    })

    const setDetailPageID = (id: string) => {
      detailPage.id = Number(id)
      detailPage.isSeminar = false
    }
    const setDetailPageID_s = (id: string) => {
      detailPage.id = Number(id)
      detailPage.isSeminar = true
    }
    const detail = computed(() => {
      let currentItem
      if (!detailPage.isSeminar) {
        currentItem = items.filter(
          (el: any) => el.id === detailPage.id
        )
      } else {
        currentItem = items_s.filter(
          (el: any) => el.id === detailPage.id
        )
      }

      if (currentItem.length === 0) return {}

      const detailData = {
        activeFlag: currentItem[0].active_flg,
        link: `/search/hospital/detail/${currentItem[0].hospital_id}`,
        backLink: '../list',
        hospitalInfo: [
          {
            label: '病院名',
            content: currentItem[0].hospital_name
          },
          {
            label: '住所',
            content:
              currentItem[0].prefectures + currentItem[0].hospital_address
          },
          {
            label: '電話番号',
            content: currentItem[0].tel
          },
          {
            label: '申し込み日時',
            content: currentItem[0].regist_dt
          }
        ],
        entryData: [
          {
            label: '見学希望日時',
            content: currentItem[0].preferred_date
          },
          {
            label: '希望内容、質問など',
            content: currentItem[0].preferred_note
          },
          {
            label: 'その他',
            content: currentItem[0].note
          }
        ]
      }
      if (detailPage.isSeminar) {
        detailData.link = `/search/hospital/detail/${currentItem[0].hospital_id}?tab=latter&id=${currentItem[0].s_training_id}`
        detailData.backLink = '../list?tab=1'
        detailData.hospitalInfo = [
          {
            label: '病院名',
            content: currentItem[0].hospital_name
          },
          {
            label: '専門研修プログラム',
            content: currentItem[0].program
          },
          {
            label: '住所',
            content:
              currentItem[0].prefectures + currentItem[0].hospital_address
          },
          {
            label: '電話番号',
            content: currentItem[0].tel
          }
        ]
      }

      return detailData
    })

    return {
      items,
      items_s,
      items_reco,
      detail,
      setDetailPageID,
      setDetailPageID_s,
      state
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.tab) {
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: 42px;
}
</style>
